import(/* webpackMode: "eager" */ "/vercel/path0/src/app/[locale]/tinklarastis/page.tsx");
